/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	ISchemaScopedTemplateModel,
	TGenericBlueprintSchema,
	TGenericModelNode
} from "@adapptio/lib-blueprint";
import { IInspectorControls } from "../InspectorTypes";
import { getInspectorControls } from "./inspectorControls";

export const ControlScopedTemplate = (_model: TGenericModelNode): IInspectorControls => {
	const model = _model as ISchemaScopedTemplateModel<TGenericBlueprintSchema>;
	return getInspectorControls(model?.template);
};
